
import gql from 'graphql-tag';

export const VERIFY_EMAIL = gql`
query VerifyEmail($email: String) {
  verifyEmail(email: $email) {
    success
  }
}`;
